export function isVisibility(x) {
    return x != null && typeof x == 'string' && (x == 'private' || x == 'public' || x == 'protected');
}
//# sourceMappingURL=Visibility.js.map